import type { PaginatedData } from '~/domains/services/interfaces/paginated-data.interface';
import { createQueryString } from '~/domains/common/utils/queryString';

import type {
  LoyaltyProgramsResponse,
  LoyaltyProgramStatus,
  LoyaltyRewardHistoryQuery,
  LoyaltyRewardHistoryRecord,
} from '../types/gamification.types';

import { gamificationInstance } from './gamification.service.instance';

export const getLoyaltyPrograms = async (): Promise<LoyaltyProgramsResponse> => {
  const response = await gamificationInstance.get('/loyalty/programs');
  return response.data;
};

export const getLoyaltyProgramStatus = async (
  programId: string
): Promise<LoyaltyProgramStatus> => {
  const response = await gamificationInstance.get(`/loyalty/programs/${programId}/status`);
  return response.data;
};

export const getLoyaltyRewardHistory = async (
  programId: string,
  {
    limit = 20,
    offset = 0,
    month,
    year,
  }: LoyaltyRewardHistoryQuery,
): Promise<PaginatedData<LoyaltyRewardHistoryRecord>> => {

  const queryString = createQueryString({
    limit,
    offset,
    month,
    year,
  });
  const response = await gamificationInstance.get(
    `/loyalty/programs/${programId}/history${queryString}`);
  return response.data;
};

export interface GamificationPusherAuthPayload {
  socket_id: string;
  channel_name: string;
}

export interface GamificationPusherAuthResponse {
  auth: string;
  channel_data?: string;
}

/**
 * Signs a Pusher private-channel subscription for the authenticated user.
 * The server signs only the caller's own `private-gamification-user-{userId}` channel
 * (requesting another user's channel → 403). Bearer token is attached by the
 * `gamificationInstance` interceptor.
 */
export const authenticateGamificationChannel = async (
  payload: GamificationPusherAuthPayload
): Promise<GamificationPusherAuthResponse> => {
  const response = await gamificationInstance.post<GamificationPusherAuthResponse>(
    '/pusher/auth',
    payload
  );
  return response.data;
};
